export const RED_PALETTE = ["#ef4129", "#f47060", "#f8a09a", "#fccdc9", "#cacbce"] as const;

// Wider palette for donut charts — red, coral, pink, purple, blue-gray, teal, neutral
export const DONUT_PALETTE = [
  "#ef4129", // red (primary)
  "#e8658b", // rose
  "#c084c0", // purple
  "#8b7fc7", // indigo
  "#5fa0c8", // steel blue
  "#4db8a4", // teal
  "#cacbce", // neutral gray (always used for "Other")
] as const;

/**
 * The analytics charts' colours by name, for UI accents that should read as
 * the same family as the charts (dashboard icon chips, status pills). Every
 * value is an entry of the palettes above — never add a colour here that the
 * charts do not use.
 */
export const CHART_ACCENTS = {
  red: DONUT_PALETTE[0],
  rose: DONUT_PALETTE[1],
  purple: DONUT_PALETTE[2],
  indigo: DONUT_PALETTE[3],
  steel: DONUT_PALETTE[4],
  teal: DONUT_PALETTE[5],
  coral: RED_PALETTE[1],
} as const;

export type ChartAccent = keyof typeof CHART_ACCENTS;

/** A chart colour at a given opacity (0–1), as an 8-digit hex for inline styles. */
export function chartAccentTint(accent: ChartAccent, opacity: number): string {
  const alpha = Math.round(Math.min(1, Math.max(0, opacity)) * 255)
    .toString(16)
    .padStart(2, "0");
  return `${CHART_ACCENTS[accent]}${alpha}`;
}

export const PRIMARY_RED = "#ef4129";
export const PRIMARY_RED_BAR = "#ef4129";
export const PRIMARY_RED_BAR_BORDER = "#ef4129";
export const PRIMARY_RED_BAR_HOVER = "#f47060";

/** Solid baseline under flat timeline charts (upload activity). */
export const CHART_BASELINE = "#e4e4e7";

const compactFormatter = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export function formatCompactNumber(value: number): string {
  return compactFormatter.format(value);
}
